import React from "react";
import { Link } from "react-router-dom";
import { Plus, Library } from "lucide-react";
import { Layout } from "../components/layout";

interface DashboardCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  link: string;
}

function DashboardCard({ icon, title, description, link }: DashboardCardProps) {
  return (
    <Link
      to={link}
      className="p-6 bg-slate-800/50 backdrop-blur-xl rounded-xl border border-white/10 hover:border-blue-500/50 transition-all group"
    >
      <div className="flex items-center gap-3 mb-3">
        <div className="text-blue-400">{icon}</div>
        <h2 className="text-xl font-semibold text-white group-hover:text-blue-400 transition-colors">
          {title}
        </h2>
      </div>
      <p className="text-slate-400">{description}</p>
    </Link>
  );
}

export function DashboardPage() {
  return (
    <Layout fullWidth>
      <div className="max-w-7xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between mb-8">
          <h1 className="text-3xl font-bold text-white">Dashboard</h1>
          <Link
            to="/generator"
            className="flex items-center gap-2 px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-lg transition-colors"
          >
            <Plus size={16} />
            New Pattern
          </Link>
        </div>

        <div className="grid gap-6 md:grid-cols-1">
          <DashboardCard
            icon={<Library size={24} />}
            title="Block Patterns"
            description="Manage your saved block patterns"
            link="/dashboard/blocks"
          />
        </div>
      </div>
    </Layout>
  );
}
